import { render, staticRenderFns } from "./NewsletterSubscribe.vue?vue&type=template&id=fa58058e&scoped=true"
import script from "./NewsletterSubscribe.vue?vue&type=script&lang=js"
export * from "./NewsletterSubscribe.vue?vue&type=script&lang=js"
import style0 from "./NewsletterSubscribe.vue?vue&type=style&index=0&id=fa58058e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa58058e",
  null
  
)

export default component.exports